import {Button, Colors, MagicBox} from "@brg/ui"
import { LayoutConst } from "core"
import styled, { css } from "styled-components"
import {ASPECT_RATIO} from "../../constants/aspectRatio";

export const SummaryInner = styled.div<{
    fullWidth?: boolean
    isSuccessfulOrder?:boolean
    isGift?: boolean
    isWhiteBg?: boolean
    deliveryAddress?:boolean
}>`
        // width: ${p => p.fullWidth ? "100%" : "500px"};
    width: ${p => p.fullWidth ? "100%" : "540px"};
    height: 100%;
    height: fit-content;
    background-color: ${p => p.isWhiteBg ? Colors.galBlack5 : p.theme.payment.summary};
    border-radius: 8px;
    padding: 32px 24px;
    display: flex;
    flex-direction: column;

    ${p => p.deliveryAddress && css`
        width: 564px;
   `};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
    width: ${p => p.fullWidth ? "100%" : "408px"};
    padding: 16px 24px 24px 24px;

    ${({isSuccessfulOrder}) => (isSuccessfulOrder) && css`
            width: 500px;
        `}

    ${p => p.deliveryAddress && css`
             width: 432px;
        `}
}

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
        padding:  16px 16px 24px 16px;
        background-color: ${Colors.galBlack5};

        ${({isSuccessfulOrder}) => (isSuccessfulOrder) && css`
            width: 500px;
        `}
    }

    @media (max-width: ${LayoutConst.screen.s + 1}px) {
        ${({isSuccessfulOrder}) => (isSuccessfulOrder) && css`
            width: 100%;
            padding:  16px;
        `}
    }


    ${({isGift}) => (isGift) && css`
        width: 708px;

        @media (max-width: ${LayoutConst.screen.mac13}px) {
            width: 544px;
            padding: 24px 16px 32px;
        }

        @media (max-width: ${LayoutConst.screen.l}px) {
            // width: 400px;
            width: 100%;
        }

        @media (max-width: ${LayoutConst.screen.s}px) {
            width: 100%;
            padding: 0px;
            background-color: inherit;
        }
        // @media (max-width: ${LayoutConst.screen.s}px) {
        //     padding: 0px;
        //     background-color: inherit;
        // }
    `}

    ${p => p.deliveryAddress && css`
        padding: 24px 16px;
        @media (max-width: ${LayoutConst.screen.mac13}px) {
            padding: 24px 16px;
        }
        @media (max-width: ${LayoutConst.screen.l}px) {
            padding: 24px 16px;
        }
        @media (max-width: ${LayoutConst.screen.s}px) {
            padding:10px
        }
    `}
`

export const SummaryBigText = styled.div<{ isGift?: boolean}>`
    font-family: Inter;
    font-size: 28px;
    line-height: 34px;
    font-weight: 600;
    letter-spacing: -0.02em;
    text-align: left;
    display: flex;
    align-items: center;
    margin-bottom: ${p => p.isGift ? 8: 0}px;

    color: ${Colors.galBlack100};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 17px;
        line-height: 22px;
    }
`

export const SummaryTotalText = styled.div`
    font-family: Inter;
    font-size: 26px;
    line-height: 32px;
    font-weight: 600;
    letter-spacing: -0.02em;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-end;

    color: ${p => p.theme.payment.bigText};

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media screen and (max-width: ${LayoutConst.screen.s}px) {
        font-size: 17px;
        line-height: 22px;
    }
`

export const SummaryPart = styled.div<{size?: number, justify?: string}>`
    display: flex;
    align-items: center;
    justify-content: ${p => p.justify || 'flex-end'};
    height: 100%;
    min-width: 100px;

    > div {
        width: ${p => p.size || 24}px;
        height: ${p => p.size || 24}px;
    }
`

export const SummaryTotalTextValue = styled(SummaryTotalText)`
    font-size: 23px;
    font-style: normal;
    font-weight: 600;
    line-height: 27px;
    color: ${Colors.galBlack100};

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 17px;
        line-height: 22px;
    }
`

export const SummaryInfoListWrapper = styled.div<{
    mobile?: boolean
    offsetTop?: number 
    offsetBottom?: number
}>`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: ${p => p.offsetTop !== undefined ? p.offsetTop : 24}px;
    // max-height: 250px;
    max-width: 100%;
    width: 100%;
    // overflow-y: scroll;
    margin-bottom: ${p => p.offsetBottom !== undefined ? p.offsetBottom : 16}px;

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
        max-height: none;
        max-width: none;
        margin-top: ${p => p.offsetTop !== undefined ? p.offsetTop : 16}px;
    }
    @media screen and (max-width: ${LayoutConst.screen.s}px) {
        gap: 10px;
    }
`

export const SummaryInfo = styled.div<{sidePadding?:boolean, bigBottomPadding?: boolean, paymentSuccess?: boolean, offPadding?:any, topPadding?:boolean}>`
    display: flex;
    flex-direction: row;
    padding: ${p => p.offPadding ? 0 : p.sidePadding ? '0 16px' : p.bigBottomPadding ? '16px 16px 24px 16px' : '16px'};

    ${p => p.topPadding && css`
        padding-top: 16px;
    `};

    @media (max-width: ${LayoutConst.screen.s + 1}px) {
        padding: ${p => p.sidePadding ? 0 : p.paymentSuccess ? '16px': '16px 0 0 0'};
    }
        
    @media (max-width: ${LayoutConst.screen.sm}px) {
        padding: ${p => p.sidePadding ? 0 : '16px 0 0 0'};
    }
`

export const SummaryCardImg = styled.img<{isReleaseCard?: boolean}>`
    max-width: 116px;
    max-height: 116px;
    object-fit: contain;
    margin-right: 23px;

    ${({isReleaseCard}) => isReleaseCard && css`
        @media (max-width: ${LayoutConst.screen.mac13}px) {
            max-width: 69px;
            max-height: 96px;
            margin-right: 16px;
        }
    `}
`

export const SummaryLine = styled.div<{isGray?: boolean, mt?: number, mb?: number, topLine?:boolean}>`
    width: 100%;
    height: 1px;
    background-color: ${p => p.isGray ? Colors.galBlack47 : Colors.galBlack73};
        // margin-bottom: ${p => p.mb !== undefined ? p.mb : 16}px;
        // margin-top: ${p => p.mt !== undefined ? p.mt : 0}px;
    margin-bottom: 16px;
    margin-top: ${p => p.topLine ? '24px' : '16px'};

    @media (max-width: ${LayoutConst.screen.s}px) {
        margin-top: 16px;
    }
`

export const SummaryPrice = styled.div<{mt?: number}>`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: ${p => p.mt !== undefined ? p.mt : 16}px;
`


export const SummaryTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 38px;
`

export const SummaryInfoGrid = styled.div`
    display: grid;
    grid-template-columns: 100px 1fr;
    column-gap: 32px;
    row-gap: 4px;
`

export const CalendarImagePreviewWrapper = styled.div<{
    mobile: boolean
    width?: string
}>`
    width: ${p => p.width ? p.width: "auto"};
    min-width: 70px;
    max-width: ${p => p.mobile ? "70px" : "80px"};
    border-radius: 3px;
    overflow: hidden;
    margin-right: ${p => p.mobile ? "10px" : "23px"};
    margin-bottom: ${p => p.mobile ? "24px" : "0px"};
`

export const CardWrapper = styled.div<{
    isHorizontal?: boolean,
    width: number;
}>`
    width: ${p => p.isHorizontal ? p.width * ASPECT_RATIO : p.width}px;
    height: ${p => p.isHorizontal ? p.width : p.width * ASPECT_RATIO}px;
    box-sizing: border-box;
    // display: grid;
    // grid-template-rows: 30px auto 110px;
    background: #FEFEFE;
    margin-right: 16px;
    > div {
        background: none;
    }

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        width: ${p => p.isHorizontal ? 140 : 100}px;
        height: ${p => p.isHorizontal ? 100 : 140}px;
    }

    @media screen and (max-width: ${LayoutConst.screen.s}px) {
        // width: 100px;
            // height: ${p => p.isHorizontal ? 75 : 140}px;
            //  width: ${p => p.isHorizontal ? 149 : 92}px;
            //  height: ${p => p.isHorizontal ? 92 : 129}px;
        margin-right: 10px;
    }
`

export const CalendarWrapper = styled.div<{
    isHorizontal?: boolean;
    isFree?:boolean
}>`
    min-width: ${p => p.isHorizontal ? 160 : p.isFree ? 115 : 76}px!important;
    width: ${p => p.isHorizontal ? 160 : p.isFree ? 115 : 76}px;
    height: ${p => p.isHorizontal ? 115 : p.isFree ? 160 : 160}px;
    background: #fff;
    margin-right: 16px;
    min-width: 70px;

    ${p => p.isHorizontal && css`
    >div>div{
        height: 210mm !important;
        padding: 10mm 10mm 15mm !important;
    }
`};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        min-width: ${p => p.isHorizontal ? 140 : p.isFree ? 100 : 66}px!important;
        width: ${p => p.isHorizontal ? 140 : p.isFree ? 100 : 66}px;
        height: ${p => p.isHorizontal ? 100 : p.isFree ? 140 : 140}px;
    }

        @media (max-width: ${LayoutConst.screen.md}px) {
        margin-right: 16px;
    };
`;


const commonStylesInfoText = css`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  color: ${Colors.galBlack73};
`;

export const InfoTitle= styled.div<{paddingRight?:boolean, receiveGift?: boolean, textV1?: boolean, noMarginBottom?: boolean, paymentSuccess?: boolean}>`
    ${commonStylesInfoText};
    font-size: 20px;
    line-height: 25px;
    font-weight: 600;
    color: ${Colors.galBlack100};
    margin-bottom: ${({noMarginBottom}) =>noMarginBottom ? 0 : 16}px;
    letter-spacing: -0.02em;
    word-break: break-word;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 17px;
        line-height: 22px;
        margin-bottom: ${({noMarginBottom}) =>noMarginBottom ? 0 : 16}px;

        ${p => p.paddingRight && css`
      padding-right: 32px;
    `}
    };

    @media (max-width: ${LayoutConst.screen.l}px) {
        ${p => p.paddingRight && css`
      padding-right: 16px;
    `};

        font-size: 17px;
        line-height: 22px;
    };

    @media (max-width: ${LayoutConst.screen.s + 1}px) {
        ${p => p.paddingRight && css`
      padding-right: 0;
    `};

        ${p => p.receiveGift && css`
      margin-bottom: 0;
    `};
    };
`;


export const SummaryInfoPrice = styled.div`
    display:grid;
    grid-template-columns: 1fr;
    width: 100%;
    gap: 8px;
    align-items: flex-end;
    margin-top: 16px;


    @media (max-width: ${LayoutConst.screen.l}px) {
        max-width: none;
        margin-top: 10px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        //max-width: calc(100% - 80px);
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        margin-top: 0px;
    }
`;

export const SummaryInfoLabel= styled.div`
  ${commonStylesInfoText};
  font-size: 13px;
  line-height: 16px;
`;

export const SummaryInfoValue= styled.div`
${commonStylesInfoText};
    color: ${Colors.galBlack100};
    font-size: 23px;
    line-height: 27px;
    font-weight: 600;
    letter-spacing: -0.02em;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    > div {
        height: 24px!important;
        width: 24px!important;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 17px;
        line-height: 22px;

        > div {
            height: 16px!important;
            width: 16px!important;
        }
    }

    ::first-letter {
        text-transform: uppercase;
    }

`;

export const ChooseUserCommentWrapper = styled(MagicBox)`
    gap: 12px;

    @media (max-width: ${LayoutConst.screen.s}px) {
        gap: 8px;
        margin-top: 16px;
    }
`

export const ArtistThumbNail = styled.img`
    width: 24px;
    height: 24px;
    margin-right: 8px;
`

export const ArtistWrapper = styled(MagicBox)`
    color: ${Colors.galBlack100};
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    .close-icon-wrapper {
        margin-right: 0px;
    }
`

export const NoWrapLabel = styled.span<{noMarginSide?:boolean}>`
    white-space: nowrap;
    margin: 0px 40px;

    ${p => p.noMarginSide && css`
        margin: 0;
    `}
`

export const CheckBoxWrapper = styled.div`
    // padding: 8px 0px;
    padding: 0px;
`

export const SpecifyRecipientButton = styled(Button.RectButtonMedium)<{fullWidth?: boolean}>`
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    white-space: nowrap;
    border: 1px solid ${Colors.galBlack31};
    height: 36px;
    ${p => p.fullWidth ? 'width: 100%;' : ''}

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        padding: 8px 24px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
    }
`

export const SelectedArtisWrapper = styled(MagicBox)`
    margin-top: 16px;

    > div {
        margin-bottom: 0px !important;
        margin-right: 0px !important;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        >div>div{
            font-size: 13px;
            line-height: 16px;
        img {
            width: 20px;
            height: 20px;
            }
        }
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        margin-top: 16px;
    }
`

export const SpecifyRecipientBlock = styled(MagicBox)`
    width:100%;
    margin-top:16px;
    align-items: center;
    justify-content: space-between;
    min-height: 36px;

    @media (max-width: ${LayoutConst.screen.s}px) {
        justify-content: space-between;
        flex-direction: column;
        gap:16px;
        align-items: flex-start;
        min-height: auto;
    }
`
export const GapBlock = styled(MagicBox)`
    gap: 4px;
    flex-direction: column;
 `

import {Button, Colors, MagicBox} from "@brg/ui"
import { LayoutConst } from "core"
import styled, { css } from "styled-components"
import {ASPECT_RATIO} from "../../constants/aspectRatio";

export const SummaryInner = styled.div<{
    fullWidth?: boolean
    isSuccessfulOrder?:boolean
    isGift?: boolean
    isWhiteBg?: boolean
    deliveryAddress?:boolean
}>`
        // width: ${p => p.fullWidth ? "100%" : "500px"};
    width: ${p => p.fullWidth ? "100%" : "540px"};
    height: 100%;
    height: fit-content;
    background-color: ${p => p.isWhiteBg ? Colors.galBlack5 : p.theme.payment.summary};
    border-radius: 8px;
    padding: 32px 24px;
    display: flex;
    flex-direction: column;

    ${p => p.deliveryAddress && css`
        width: 564px;
   `};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
    width: ${p => p.fullWidth ? "100%" : "408px"};
    padding: 16px 24px 24px 24px;

    ${({isSuccessfulOrder}) => (isSuccessfulOrder) && css`
            width: 500px;
        `}

    ${p => p.deliveryAddress && css`
             width: 432px;
        `}
}

    @media (max-width: ${LayoutConst.screen.l}px) {
        width: 100%;
        padding:  16px 16px 24px 16px;
        background-color: ${Colors.galBlack5};

        ${({isSuccessfulOrder}) => (isSuccessfulOrder) && css`
            width: 500px;
        `}
    }

    @media (max-width: ${LayoutConst.screen.s + 1}px) {
        ${({isSuccessfulOrder}) => (isSuccessfulOrder) && css`
            width: 100%;
            padding:  16px;
        `}
    }


    ${({isGift}) => (isGift) && css`
        width: 708px;

        @media (max-width: ${LayoutConst.screen.mac13}px) {
            width: 544px;
            padding: 24px 16px 32px;
        }

        @media (max-width: ${LayoutConst.screen.l}px) {
            // width: 400px;
            width: 100%;
        }

        @media (max-width: ${LayoutConst.screen.s}px) {
            width: 100%;
            padding: 0px;
            background-color: inherit;
        }
        // @media (max-width: ${LayoutConst.screen.s}px) {
        //     padding: 0px;
        //     background-color: inherit;
        // }
    `}

    ${p => p.deliveryAddress && css`
        padding: 24px 16px;
        @media (max-width: ${LayoutConst.screen.mac13}px) {
            padding: 24px 16px;
        }
        @media (max-width: ${LayoutConst.screen.l}px) {
            padding: 24px 16px;
        }
        @media (max-width: ${LayoutConst.screen.s}px) {
            padding:10px
        }
    `}
`

export const SummaryBigText = styled.div<{ isGift?: boolean}>`
    font-family: Inter;
    font-size: 28px;
    line-height: 34px;
    font-weight: 600;
    letter-spacing: -0.02em;
    text-align: left;
    display: flex;
    align-items: center;
    margin-bottom: ${p => p.isGift ? 8: 0}px;

    color: ${Colors.galBlack100};

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 17px;
        line-height: 22px;
    }
`

export const SummaryTotalText = styled.div`
    font-family: Inter;
    font-size: 26px;
    line-height: 32px;
    font-weight: 600;
    letter-spacing: -0.02em;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-end;

    color: ${p => p.theme.payment.bigText};

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 23px;
        line-height: 27px;
    }

    @media screen and (max-width: ${LayoutConst.screen.s}px) {
        font-size: 17px;
        line-height: 22px;
    }
`

export const SummaryPart = styled.div<{size?: number, justify?: string}>`
    display: flex;
    align-items: center;
    justify-content: ${p => p.justify || 'flex-end'};
    height: 100%;
    min-width: 100px;

    > div {
        width: ${p => p.size || 24}px;
        height: ${p => p.size || 24}px;
    }
`

export const SummaryTotalTextValue = styled(SummaryTotalText)`
    font-size: 23px;
    font-style: normal;
    font-weight: 600;
    line-height: 27px;
    color: ${Colors.galBlack100};

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 17px;
        line-height: 22px;
    }
`

export const SummaryInfoListWrapper = styled.div<{
    mobile?: boolean
    offsetTop?: number 
    offsetBottom?: number
}>`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: ${p => p.offsetTop !== undefined ? p.offsetTop : 24}px;
    // max-height: 250px;
    max-width: 100%;
    width: 100%;
    // overflow-y: scroll;
    margin-bottom: ${p => p.offsetBottom !== undefined ? p.offsetBottom : 16}px;

    @media screen and (max-width: ${LayoutConst.screen.md}px) {
        max-height: none;
        max-width: none;
        margin-top: ${p => p.offsetTop !== undefined ? p.offsetTop : 16}px;
    }
    @media screen and (max-width: ${LayoutConst.screen.s}px) {
        gap: 10px;
    }
`

export const SummaryInfo = styled.div<{sidePadding?:boolean, bigBottomPadding?: boolean, paymentSuccess?: boolean, offPadding?:any, topPadding?:boolean}>`
    display: flex;
    flex-direction: row;
    padding: ${p => p.offPadding ? 0 : p.sidePadding ? '0 16px' : p.bigBottomPadding ? '16px 16px 24px 16px' : '16px'};

    ${p => p.topPadding && css`
        padding-top: 16px;
    `};

    @media (max-width: ${LayoutConst.screen.s + 1}px) {
        padding: ${p => p.sidePadding ? 0 : p.paymentSuccess ? '16px': '16px 0 0 0'};
    }
        
    @media (max-width: ${LayoutConst.screen.sm}px) {
        padding: ${p => p.sidePadding ? 0 : '16px 0 0 0'};
    }
`

export const SummaryCardImg = styled.img<{isReleaseCard?: boolean}>`
    max-width: 116px;
    max-height: 116px;
    object-fit: contain;
    margin-right: 23px;

    ${({isReleaseCard}) => isReleaseCard && css`
        @media (max-width: ${LayoutConst.screen.mac13}px) {
            max-width: 69px;
            max-height: 96px;
            margin-right: 16px;
        }
    `}
`

export const SummaryLine = styled.div<{isGray?: boolean, mt?: number, mb?: number, topLine?:boolean}>`
    width: 100%;
    height: 1px;
    background-color: ${p => p.isGray ? Colors.galBlack47 : Colors.galBlack73};
        // margin-bottom: ${p => p.mb !== undefined ? p.mb : 16}px;
        // margin-top: ${p => p.mt !== undefined ? p.mt : 0}px;
    margin-bottom: 16px;
    margin-top: ${p => p.topLine ? '24px' : '16px'};

    @media (max-width: ${LayoutConst.screen.s}px) {
        margin-top: 16px;
    }
`

export const SummaryPrice = styled.div<{mt?: number}>`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: ${p => p.mt !== undefined ? p.mt : 16}px;
`


export const SummaryTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 38px;
`

export const SummaryInfoGrid = styled.div`
    display: grid;
    grid-template-columns: 100px 1fr;
    column-gap: 32px;
    row-gap: 4px;
`

export const CalendarImagePreviewWrapper = styled.div<{
    mobile: boolean
    width?: string
}>`
    width: ${p => p.width ? p.width: "auto"};
    min-width: 70px;
    max-width: ${p => p.mobile ? "70px" : "80px"};
    border-radius: 3px;
    overflow: hidden;
    margin-right: ${p => p.mobile ? "10px" : "23px"};
    margin-bottom: ${p => p.mobile ? "24px" : "0px"};
`

export const CardWrapper = styled.div<{
    isHorizontal?: boolean,
    width: number;
}>`
    width: ${p => p.isHorizontal ? p.width * ASPECT_RATIO : p.width}px;
    height: ${p => p.isHorizontal ? p.width : p.width * ASPECT_RATIO}px;
    box-sizing: border-box;
    // display: grid;
    // grid-template-rows: 30px auto 110px;
    background: #FEFEFE;
    margin-right: 16px;
    > div {
        background: none;
    }

    @media screen and (max-width: ${LayoutConst.screen.mac13}px) {
        width: ${p => p.isHorizontal ? 140 : 100}px;
        height: ${p => p.isHorizontal ? 100 : 140}px;
    }

    @media screen and (max-width: ${LayoutConst.screen.s}px) {
        // width: 100px;
            // height: ${p => p.isHorizontal ? 75 : 140}px;
            //  width: ${p => p.isHorizontal ? 149 : 92}px;
            //  height: ${p => p.isHorizontal ? 92 : 129}px;
        margin-right: 10px;
    }
`

export const CalendarWrapper = styled.div<{
    isHorizontal?: boolean;
    isFree?:boolean
}>`
    min-width: ${p => p.isHorizontal ? 160 : p.isFree ? 115 : 76}px!important;
    width: ${p => p.isHorizontal ? 160 : p.isFree ? 115 : 76}px;
    height: ${p => p.isHorizontal ? 115 : p.isFree ? 160 : 160}px;
    background: #fff;
    margin-right: 16px;
    min-width: 70px;

    ${p => p.isHorizontal && css`
    >div>div{
        height: 210mm !important;
        padding: 10mm 10mm 15mm !important;
    }
`};

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        min-width: ${p => p.isHorizontal ? 140 : p.isFree ? 100 : 66}px!important;
        width: ${p => p.isHorizontal ? 140 : p.isFree ? 100 : 66}px;
        height: ${p => p.isHorizontal ? 100 : p.isFree ? 140 : 140}px;
    }

        @media (max-width: ${LayoutConst.screen.md}px) {
        margin-right: 16px;
    };
`;


const commonStylesInfoText = css`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  color: ${Colors.galBlack73};
`;

export const InfoTitle= styled.div<{paddingRight?:boolean, receiveGift?: boolean, textV1?: boolean, noMarginBottom?: boolean, paymentSuccess?: boolean}>`
    ${commonStylesInfoText};
    font-size: 20px;
    line-height: 25px;
    font-weight: 600;
    color: ${Colors.galBlack100};
    margin-bottom: ${({noMarginBottom}) =>noMarginBottom ? 0 : 16}px;
    letter-spacing: -0.02em;
    word-break: break-word;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 17px;
        line-height: 22px;
        margin-bottom: ${({noMarginBottom}) =>noMarginBottom ? 0 : 16}px;

        ${p => p.paddingRight && css`
      padding-right: 32px;
    `}
    };

    @media (max-width: ${LayoutConst.screen.l}px) {
        ${p => p.paddingRight && css`
      padding-right: 16px;
    `};

        font-size: 17px;
        line-height: 22px;
    };

    @media (max-width: ${LayoutConst.screen.s + 1}px) {
        ${p => p.paddingRight && css`
      padding-right: 0;
    `};

        ${p => p.receiveGift && css`
      margin-bottom: 0;
    `};
    };
`;


export const SummaryInfoPrice = styled.div`
    display:grid;
    grid-template-columns: 1fr;
    width: 100%;
    gap: 8px;
    align-items: flex-end;
    margin-top: 16px;


    @media (max-width: ${LayoutConst.screen.l}px) {
        max-width: none;
        margin-top: 10px;
    }

    @media (max-width: ${LayoutConst.screen.md}px) {
        //max-width: calc(100% - 80px);
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        margin-top: 0px;
    }
`;

export const SummaryInfoLabel= styled.div`
  ${commonStylesInfoText};
  font-size: 13px;
  line-height: 16px;
`;

export const SummaryInfoValue= styled.div`
${commonStylesInfoText};
    color: ${Colors.galBlack100};
    font-size: 23px;
    line-height: 27px;
    font-weight: 600;
    letter-spacing: -0.02em;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    > div {
        height: 24px!important;
        width: 24px!important;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 17px;
        line-height: 22px;

        > div {
            height: 16px!important;
            width: 16px!important;
        }
    }

    ::first-letter {
        text-transform: uppercase;
    }

`;

export const ChooseUserCommentWrapper = styled(MagicBox)`
    gap: 12px;

    @media (max-width: ${LayoutConst.screen.s}px) {
        gap: 8px;
        margin-top: 16px;
    }
`

export const ArtistThumbNail = styled.img`
    width: 24px;
    height: 24px;
    margin-right: 8px;
`

export const ArtistWrapper = styled(MagicBox)`
    color: ${Colors.galBlack100};
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    letter-spacing: -0.3px;
    .close-icon-wrapper {
        margin-right: 0px;
    }
`

export const NoWrapLabel = styled.span<{noMarginSide?:boolean}>`
    white-space: nowrap;
    margin: 0px 40px;

    ${p => p.noMarginSide && css`
        margin: 0;
    `}
`

export const CheckBoxWrapper = styled.div`
    // padding: 8px 0px;
    padding: 0px;
`

export const SpecifyRecipientButton = styled(Button.RectButtonMedium)<{fullWidth?: boolean}>`
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: -0.02em;
    white-space: nowrap;
    border: 1px solid ${Colors.galBlack31};
    height: 36px;
    ${p => p.fullWidth ? 'width: 100%;' : ''}

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        padding: 8px 24px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
    }
`

export const SelectedArtisWrapper = styled(MagicBox)`
    margin-top: 16px;

    > div {
        margin-bottom: 0px !important;
        margin-right: 0px !important;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        >div>div{
            font-size: 13px;
            line-height: 16px;
        img {
            width: 20px;
            height: 20px;
            }
        }
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        margin-top: 16px;
    }
`

export const SpecifyRecipientBlock = styled(MagicBox)`
    width:100%;
    margin-top:16px;
    align-items: center;
    justify-content: space-between;
    min-height: 36px;

    @media (max-width: ${LayoutConst.screen.s}px) {
        justify-content: space-between;
        flex-direction: column;
        gap:16px;
        align-items: flex-start;
        min-height: auto;
    }
`
export const GapBlock = styled(MagicBox)`
    gap: 4px;
    flex-direction: column;
 `

